import { render } from "./ListVendorMasters.vue?vue&type=template&id=c97bd7cc"
import script from "./ListVendorMasters.vue?vue&type=script&lang=js"
export * from "./ListVendorMasters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__